// Mock data untuk fundraising sekolah
export const fundraisingData = {
  goal: 6000000, // RM 6 juta (keseluruhan projek KDU)
  current: 130000, // RM 130k terkumpul setakat ini
  donorsCount: 0, // Data sebenar tidak tersedia, akan dikemaskini dari backend
  daysLeft: 0, // Tiada had masa
  currentPhaseGoal: 500000, // RM 500k untuk sasaran awal
  
  schoolInfo: {
    name: "Sekolah Rendah Islam Integrasi Darul Ummah Akademi Tarbiyyah (SRII DUAT)",
    projectName: "Kompleks Darul Ummah (KDU)",
    location: "Lot 1389, Mukim Telok Panglima Garang, Sijangkang, Daerah Kuala Langat, Selangor",
    currentLocation: "No 48, Jalan Desa 2, Taman Desa Sijangkang, Kampung Sijangkang, 42500 Telok Panglima Garang, Selangor",
    description: "Kompleks Pendidikan Islam bersepadu yang akan menempatkan Sekolah Rendah Islam Integrasi (SRII DUAT) di atas tanah wakaf seluas 5 ekar. Projek ini hasil usaha gabungan pertubuhan Islam seperti ABIM, WADAH, dan PEPIAS Negeri Selangor.",
    theme: "Melahirkan Daie Sejuta Ummah",
    philosophy: "Al-Hikmah (gagasan Almarhum Prof. Dato Dr. Siddiq Fadzil, Tokoh Maal Hijrah Kebangsaan 2018)",
    yearEstablished: 2015,
    totalGraduates: "300+",
  },
  
  schoolImages: {
    buildingFront: "/images/kdu-building-front.png",
    buildingSide: "/images/kdu-building-side.png",
    posterAerial: "/images/kdu-poster-aerial.png",
    studentsPledge: "/images/students-pledge.png",
    studentAssembly: "/images/student-assembly.png",
    staffPhoto: "/images/staff-photo.png",
    classroomStudy: "/images/classroom-study.png",
    upkkAchievement: "/images/upkk-achievement.png",
    registration2026: "/images/registration-2026.png",
    wakafPoster: "/images/wakaf-poster.png",
  },

  // Gambar tapak projek & lawatan sebenar
  projectSite: [
    {
      src: "/images/projek/tapak-lawatan-1.jpg",
      title: "Lawatan Tapak Tanah Wakaf",
      description: "Jawatankuasa meninjau tapak tanah wakaf 5 ekar yang bakal menempatkan KDU",
    },
    {
      src: "/images/projek/tapak-lawatan-2.jpg",
      title: "Tinjauan Kawasan Projek",
      description: "Perbincangan di lokasi pembinaan Kompleks Darul Ummah",
    },
    {
      src: "/images/projek/tapak-group.jpg",
      title: "Barisan Jawatankuasa di Tapak",
      description: "Gambar kenangan warga kerja & sukarelawan di tanah wakaf",
    },
    {
      src: "/images/projek/team-sekolah.jpg",
      title: "Team di Hadapan SRII DUAT",
      description: "Lokasi sekolah sedia ada bersama sepanduk Wakaf Khas KDU",
    },
    {
      src: "/images/projek/majlis-ucapan.jpg",
      title: "Majlis Mula Projek (Fasa 1)",
      description: "Ucapan perasmian sempena Ulang Tahun SRII DUAT ke-10",
    },
    {
      src: "/images/projek/majlis-mula-1.jpg",
      title: "Majlis Perasmian Projek",
      description: "Warga & penyokong berhimpun menjayakan pelancaran wakaf",
    },
  ],

  // Statistik impak
  impact: [
    {
      number: "5 Ekar",
      label: "Tanah Wakaf Pendidikan",
      icon: "building"
    },
    {
      number: "300+",
      label: "Murid Telah Dilahirkan (Sejak 2015)",
      icon: "users"
    },
    {
      number: "2015",
      label: "Tahun SRII DUAT Beroperasi",
      icon: "school"
    },
    {
      number: "3 Fasa",
      label: "Pelan Pembangunan KDU",
      icon: "graduationCap"
    }
  ],
  
  // Faedah & Impak
  benefits: [
    {
      title: "Kurikulum Komprehensif",
      description: "Pra-tahfiz, akademik, PSRA, Kurikulum Dini Takmir Pendidikan ABIM & UPKK - pendidikan Islam integrasi yang lengkap.",
      icon: "bookOpen"
    },
    {
      title: "Kompleks Pendidikan Bersepadu",
      description: "Blok pembelajaran, kantin, surau, dan kemudahan lengkap untuk pendidikan menyeluruh di tanah wakaf 5 ekar.",
      icon: "building2"
    },
    {
      title: "Pembinaan Sahsiah",
      description: "Aktiviti usrah dan MABIT DAIE untuk memupuk semangat, budaya ilmu, dan pembinaan sahsiah Islamik yang kukuh.",
      icon: "heart"
    },
    {
      title: "Amal Jariah Berkekalan",
      description: "Sumbangan wakaf adalah pelaburan akhirat yang berkekalan dan layak mendapat potongan cukai LHDN 10%.",
      icon: "star"
    }
  ],
  
  // FAQ
  faqs: [
    {
      question: "Bagaimana cara untuk berinfaq?",
      answer: "Anda boleh berinfaq melalui: 1) Toyyib Pay (online), 2) Pemindahan bank ke akaun Maybank 562058606120, atau 3) Hubungi admin di 019-974 2102. Sila gunakan rujukan 'WAKAF KDU' atau 'WAKAF KHAS'."
    },
    {
      question: "Adakah infaq saya mendapat potongan cukai?",
      answer: "Ya! Sumbangan wakaf tunai layak mendapat potongan cukai LHDN 10% di bawah Subseksyen 44(11D) Akta Cukai Pendapatan 1967. Resit rasmi akan dikeluarkan oleh Perbadanan Wakaf Selangor (PWS)."
    },
    {
      question: "Apakah Kompleks Darul Ummah (KDU)?",
      answer: "KDU adalah kompleks pendidikan Islam bersepadu yang akan dibina di atas tanah wakaf 5 ekar di Sijangkang. Ia akan menempatkan SRII DUAT, pusat pendidikan, belia, dan masyarakat dengan kemudahan lengkap."
    },
    {
      question: "Berapa jumlah dana diperlukan dan berapa yang telah terkumpul?",
      answer: "Jumlah keseluruhan projek KDU adalah RM6 juta (untuk semua fasa). Setakat ini, RM130k telah terkumpul sejak 2013. Sasaran awal untuk memulakan projek adalah RM500k."
    },
    {
      question: "Apakah itu sumbangan wakaf?",
      answer: "Wakaf adalah sumbangan harta untuk tujuan kebajikan yang kekal. Sumbangan wakaf untuk KDU adalah amal jariah berkekalan - pahalanya terus mengalir selagi kompleks ini memberi manfaat kepada pelajar dan masyarakat."
    },
    {
      question: "Siapa yang menguruskan projek ini?",
      answer: "Projek ini adalah usahasama antara ABIM Negeri Selangor, WADAH, PEPIAS, Perbadanan Wakaf Selangor (PWS), dan Yayasan Takmir. Ia didaftarkan dengan PWS dan mendapat kebenaran kutipan tabung wakaf."
    },
    {
      question: "Bila projek ini akan mula dibina?",
      answer: "Majlis Mula Projek Kompleks Darul Ummah (Fasa 1) telah diadakan pada 6 Jun 2026 sempena Ulang Tahun SRII DUAT ke-10. Pembinaan akan bermula apabila dana mencukupi."
    },
    {
      question: "Bagaimana saya boleh mendapat resit atau hantar slip sumbangan?",
      answer: "WhatsApp terus ke https://wa.me/60199742102 atau hubungi admin di 019-974 2102. Anda juga boleh hubungi Guru Besar SRII DUAT di 013-210 2589."
    }
  ],
  
  // Payment info
  paymentInfo: {
    bankName: "Maybank",
    accountNumber: "562058606120",
    accountName: "ABIM Negeri Selangor - Wakaf KDU",
    reference: "WAKAF KDU atau WAKAF KHAS",
    qrCode: "https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=562058606120",
    toyyibPayLink: "https://toyyibpay.com/Wakaf-Khas-KDU-ABIM-Selangor",
    whatsappAdmin: "https://wa.me/60199742102",
    contactAdmin: "019-974 2102",
    contactPrincipal: "013-210 2589",
    taxExemption: "Layak potongan cukai LHDN 10% di bawah Subseksyen 44(11D) Akta Cukai Pendapatan 1967"
  }
};

// Manifesto chapters
export const manifestoChapters = [
  {
    number: "01",
    title: "Melahirkan Daie Sejuta Ummah",
    content: "Tema SRII DUAT adalah melahirkan daie yang berilmu, berakhlak, dan berjiwa ummah. Kami percaya pendidikan Islam integrasi adalah asas pembentukan generasi cemerlang."
  },
  {
    number: "02",
    title: "Falsafah Al-Hikmah",
    content: "Pendekatan falsafah pendidikan Al-Hikmah berdasarkan gagasan Almarhum Prof. Dato Dr. Siddiq Fadzil, Tokoh Maal Hijrah Kebangsaan 2018 - menggabungkan ilmu dunia dan akhirat."
  },
  {
    number: "03",
    title: "Wakaf Pendidikan Berkekalan",
    content: "Kompleks Darul Ummah dibina di atas tanah wakaf 5 ekar - sumbangan anda adalah amal jariah berkekalan yang akan terus memberi manfaat kepada generasi akan datang."
  }
];

// Project phases
export const projectPhases = [
  {
    phase: "Fasa 1A",
    title: "Kerja Cerucuk & Awalan",
    cost: 530866,
    description: "Cerucuk konkrit bertetulang, pembersihan tapak & kerja tanah, kerja awalan"
  },
  {
    phase: "Fasa 1B",
    title: "Blok Pembelajaran",
    cost: 4151189,
    description: "Sekolah - Blok Pembelajaran, kerja mekanikal & elektrikal, infrastruktur tempatan"
  },
  {
    phase: "Fasa 1C",
    title: "Kantin & Surau",
    cost: 1069367,
    description: "Kantin & Surau - kerja mekanikal & elektrikal"
  }
];
